(() => {
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');

  // Header dropdowns: open on hover, stay open while the pointer is over the
  // trigger or the panel, and close only after a short grace period.
  document.querySelectorAll('header-menu details').forEach((details) => {
    const summary = details.querySelector('summary');
    const menu = details.closest('header-menu');
    let closeTimer;

    const open = () => {
      clearTimeout(closeTimer);
      if (!details.open) {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (details.matches(':hover') || details.contains(document.activeElement)) return;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      }, 450);
    };

    details.addEventListener('mouseenter', () => desktop.matches && open());
    details.addEventListener('mouseleave', () => desktop.matches && scheduleClose());

    // Dawn closes the panel on focusout; ignore that while the pointer is still inside.
    if (menu && typeof menu.close === 'function') {
      const originalClose = menu.close.bind(menu);
      menu.close = () => {
        if (desktop.matches && details.matches(':hover')) return;
        originalClose();
      };
    }

    // Clicking the trigger on desktop keeps the panel open instead of toggling it shut
    // right after hover already opened it.
    summary.addEventListener('click', (event) => {
      if (!desktop.matches) return;
      if (details.open && details.matches(':hover')) {
        event.preventDefault();
        clearTimeout(closeTimer);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
        summary.focus();
      }
    });
  });
})();
